import { createApp, h } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import vuetify from './plugins/vuetify';
import router from './router';
import axios from 'axios';
import App from "./App.vue";
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './registerServiceWorker';
import VDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

const moment = require('moment-timezone');
moment.tz.setDefault("Etc/UTC");

const app = createApp({
  render: () => h(App)
});

if (process.env.NODE_ENV == 'production') {
  // Enable this on production
  window.addEventListener("contextmenu", (event) => {
    event.preventDefault();
  });

  document.addEventListener('contextmenu', (e) => e.preventDefault());
  document.onkeydown = (e) => {
    if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J' || e.key === 'C'))) {
      return false;
    }
  };

  document.onkeydown = (e) => {
    if (e.keyCode === 123 || // F12
      (e.ctrlKey && e.shiftKey && e.keyCode === 'I'.charCodeAt(0)) || // Ctrl+Shift+I
      (e.ctrlKey && e.shiftKey && e.keyCode === 'J'.charCodeAt(0))) { // Ctrl+Shift+J
      return false;
    }
  };
}

app.config.productionTip = false;
window.axios = axios;

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.use(vuetify);
app.use(router);
app.component('VDatePicker', VDatePicker);
app.mount("#app");
